
import { ensureInstance } from "../../utils/typeUtils";
import { Harm } from "./Harm";


export class InternalImpact  {

    financial: Harm = new Harm();
    reputational: Harm = new Harm();
    operational: Harm = new Harm();
    legal: Harm = new Harm();

    constructor(init?: Partial<InternalImpact>) {
        Object.assign(this, init);
        this.financial = ensureInstance(this.financial, Harm); 
        this.reputational = ensureInstance(this.reputational, Harm);
        this.operational = ensureInstance(this.operational, Harm);
        this.legal = ensureInstance(this.legal, Harm);
    }
}

export class ExternalImpact  {
    people: Harm = new Harm();
    organisations: Harm = new Harm();
    ecosystems: Harm = new Harm();

    constructor(init?: Partial<ExternalImpact>) {
        Object.assign(this, init);
        this.people = ensureInstance(this.people, Harm);
        this.organisations = ensureInstance(this.organisations, Harm);
        this.ecosystems = ensureInstance(this.ecosystems, Harm);
    }
}

export class AISystemImpact {
    internal: InternalImpact = new InternalImpact();
    external: ExternalImpact = new ExternalImpact();

    constructor(init?: Partial<AISystemImpact>) {
        Object.assign(this, init);
        this.internal = ensureInstance(this.internal, InternalImpact);
        this.external = ensureInstance(this.external, ExternalImpact);  
    }
}

